var exports = {
  "k": "xfd349460--d0419e--container",
};

module.exports = exports;
